/* import __COLOCATED_TEMPLATE__ from './lsg-user-image-bubbles.hbs'; */
import Component from '@glimmer/component';
import clsx from 'clsx';

class LsgUserImageBubblesComponent extends Component {
  get classNames() {
    const isOverlapImages = this.args.isOverlapImages ?? true;

    return clsx(
      this.args.class,
      'LSG-c-user-image-bubbles',
      isOverlapImages && 'LSG-c-user-image-bubbles--overlap-images',
    );
  }

  get bubbleContainerClassNames() {
    return clsx(
      'image-bubble-container LSG-l-grid',
      this.args.isWrap && 'wrap',
    );
  }

  get totalCount() {
    return (
      this.args.totalCount ??
      this.args.userImageObjectsWithTooltips?.length ??
      this.args.userImages?.length
    );
  }

  get bubbleHash() {
    const maxCountToShow = this.args.maxCountToShow ?? 3;

    const images =
      this.args.userImageObjectsWithTooltips?.slice(0, maxCountToShow) ??
      this.args.userImages?.slice(0, maxCountToShow).map((imageUri) => ({ imageUri })) ??
      [];

    return { images, remaining: this.totalCount - images.length };
  }

  get titleText() {
    const { titleText } = this.args;

    return titleText ? `${this.totalCount} ${this.args.titleText}` : null;
  }
}

export default LsgUserImageBubblesComponent;
